import * as urls from "../../../api/urls";
import { useEffect, useRef, useState } from "react";
import { Utils } from "helpers/utils";
import { APIClient } from "api/apiCore";
import MasterPage1Column from "pages/MasterPage1Column";
import Select, { components, useStateManager } from 'react-select';
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import SelectDropdownAsyncWpTags from "components/SelectDropdownAsyncWpTags";
import { DropdownOption } from "types";
import HelpInfo from "components/HelpInfo";


const GeneralSettingComponent: React.FC<{}> = ({ }) => {
  const { dispatch, useAppSelector } = useRedux();
  const [ddlUser, setDdlUser] = useState<any[]>([]);
  const [userToAddRemove, setUserToAddRemove] = useState<any[]>([]);
  const [supplierUserToAddRemove, setSupplierUserToAddRemove] = useState<any[]>([]);
  const [initTagRecureTask, setInitTagRecureTask] = useState<DropdownOption[]>([]);
  const [hookManagerUsers, setHookManagerUsers] = useState<any[]>([]);
  const [taskRecuranceAdminUsers, setTaskRecuranceAdminUsers] = useState<any[]>([]);
  const [observerChat2sUsers, setObserverChat2sUsers] = useState<any[]>([]);
  const [observerSup2sUsers, setObserverSup2sUsers] = useState<any[]>([]);
  const [itSupportUsers, setItSupportUsers] = useState<any[]>([]);
  const [adminUsers, setAdminUsers] = useState<any[]>([]);

  const storeData = createSelector(
    (state: any) => state.Profile2,
    (p2) => ({
      isAdmin: p2.isAdmin,
    })
  );
  const { isAdmin } = useAppSelector(storeData);


  useEffect(() => {
    const rs = new APIClient().fnPostForm(urls.SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL, {})
      .then(rs => {
        // console.log('SEARCH_CHAT_ROOM_FOR_MEMBER_MANAGE_USER_DDL:', rs);
        setDdlUser(rs);
      })
      .catch(er => Utils.HandleException(er, true));

    const rs2 = new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setUserToAddRemove(forDll);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_SUPPLIER_RECEIPTANCE, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setSupplierUserToAddRemove(forDll);
      }).catch(er => Utils.HandleException(er, true));

    const initTag = new APIClient().fnPostForm(urls.UC_INIT_TAG_IN_RECURANCE_TASK_LOAD, {})
      .then(rs => {
        setInitTagRecureTask(rs);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ALLOW_HOOK_MANAGER, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setHookManagerUsers(forDll);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_TASK_RECURANCE_ADMIN, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setTaskRecuranceAdminUsers(forDll);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_OBSERVER_CHAT2S, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setObserverChat2sUsers(forDll);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_OBSERVER_SUP2S, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setObserverSup2sUsers(forDll);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_EMPLOYEE_WHO_ARE_IT_SUPPORT, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setItSupportUsers(forDll);
      }).catch(er => Utils.HandleException(er, true));

    new APIClient().fnPostForm(urls.LOAD_ADMIN_USERS, {})
      .then(rs => {
        const forDll = rs.map((x: any) => ({ value: x.userId, label: x.fullName }));
        setAdminUsers(forDll);
      }).catch(er => Utils.HandleException(er, true));
  }, []);

  const onSaveInitTagRecureTask = () => {
    try {
      const tagIds = initTagRecureTask.map(x => x.value).join(',');
      new APIClient().fnPostForm(urls.UC_INIT_TAG_IN_RECURANCE_TASK_SAVE, { tagIds: tagIds })
        .then(rs => alert('บันทึกสำเร็จ'))
        .catch(er => Utils.HandleException(er, true));
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  const onSaveEmployeeMultiSelect = (users: any[], saveUrl: string, requireAtLeastOne: boolean = false) => {
    try {
      const userId = users.map((x: any) => x.value);
      if (requireAtLeastOne && userId.length <= 0) {
        alert('ไม่มีข้อมูล');
      } else {
        new APIClient().fnPostForm(saveUrl, { userIds: userId })
          .then(rs => alert('บันทึกสำเร็จ'))
          .catch(er => Utils.HandleException(er, true));
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }

  return (
    <>
      <div className="row">
        <div className="col">
          พนักงานเข้าห้องแชท 2sonline กรณีลูกค้าใหม่ ลงทะเบียนมาเอง
          <HelpInfo infos={["กำหนดรายชื่อพนักงานที่จะถูกเพิ่มเข้าห้องแชทโดยอัตโนมัติ เมื่อมีลูกค้าใหม่ลงทะเบียนเข้ามาเองผ่านช่องทาง 2sonline"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                // className="form-control"
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setUserToAddRemove(e)}
                value={userToAddRemove}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(userToAddRemove, urls.SAVE_EMPLOYEE_WHO_ARE_2SONLINE_RECEIPTANCE)}>Save</button>
            }
          </div>
        </div>
      </div >

      <div className="row">
        <div className="col">
          พนักงานเข้าห้องแชท supplier กรณี supplier ใหม่ ลงทะเบียนมาเอง
          <HelpInfo infos={["กำหนดรายชื่อพนักงานที่จะถูกเพิ่มเข้าห้องแชทโดยอัตโนมัติ เมื่อมี Supplier ใหม่ลงทะเบียนเข้ามาเอง"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setSupplierUserToAddRemove(e)}
                value={supplierUserToAddRemove}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(supplierUserToAddRemove, urls.SAVE_EMPLOYEE_WHO_ARE_SUPPLIER_RECEIPTANCE)}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          Tag เริ่มต้นสำหรับ Tag เข้างานประจำ
          <HelpInfo infos={["กำหนด Tag เริ่มต้น ที่จะถูกใส่ให้กับโพสต์ที่สร้างจากงานประจำ (Recurring Task) โดยอัตโนมัติ"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <SelectDropdownAsyncWpTags onValueChanged={(e) => setInitTagRecureTask(e)} selectedValues={initTagRecureTask} />
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={onSaveInitTagRecureTask}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          พนักงานที่มีสิทธิ์จัดการ Hook Manager
          <HelpInfo infos={["กำหนดรายชื่อพนักงานที่มีสิทธิ์เข้าใช้งานเมนู Hook Manager สำหรับสร้าง/จัดการ Webhook ที่จะยิงออกไปยังระบบภายนอกโดยอัตโนมัติ เมื่อสถานะของงาน (Task) มีการเปลี่ยนแปลง"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setHookManagerUsers(e)}
                value={hookManagerUsers}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(hookManagerUsers, urls.SAVE_EMPLOYEE_WHO_ALLOW_HOOK_MANAGER)}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          พนักงานที่เป็นแอดมินงานประจำ (Recurring Task)
          <HelpInfo infos={["กำหนดรายชื่อพนักงานที่เป็นแอดมินของงานประจำ (Recurring Task)", "หมายเหตุ: ปัจจุบันยังไม่มีฟังก์ชันใดในระบบที่ใช้งานสิทธิ์นี้จริง (ยังไม่ผูกกับการทำงานใด)"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setTaskRecuranceAdminUsers(e)}
                value={taskRecuranceAdminUsers}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(taskRecuranceAdminUsers, urls.SAVE_EMPLOYEE_WHO_ARE_TASK_RECURANCE_ADMIN)}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          พนักงานที่เป็นผู้สังเกตการณ์ห้องแชท Chat.2S (มองเห็นทุกห้อง)
          <HelpInfo infos={["กำหนดรายชื่อพนักงานที่สามารถมองเห็นห้องแชท Chat.2S ได้ทุกห้อง แม้จะไม่ได้เป็นสมาชิกของห้องนั้นๆ"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setObserverChat2sUsers(e)}
                value={observerChat2sUsers}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(observerChat2sUsers, urls.SAVE_EMPLOYEE_WHO_ARE_OBSERVER_CHAT2S)}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          พนักงานที่เป็นผู้สังเกตการณ์ห้องแชท Supplier (มองเห็นทุกห้อง)
          <HelpInfo infos={["กำหนดรายชื่อพนักงานที่สามารถมองเห็นห้องแชท Supplier ได้ทุกห้อง แม้จะไม่ได้เป็นสมาชิกของห้องนั้นๆ", "หมายเหตุ: ปัจจุบันยังไม่มีฟังก์ชันใดในระบบที่ใช้งานสิทธิ์นี้จริง (ยังไม่ผูกกับการทำงานใด)"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setObserverSup2sUsers(e)}
                value={observerSup2sUsers}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(observerSup2sUsers, urls.SAVE_EMPLOYEE_WHO_ARE_OBSERVER_SUP2S)}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          พนักงาน IT Support (มีสิทธิ์แก้ไข Permission เพิ่มเติม)
          <HelpInfo infos={[
            "กำหนดรายชื่อพนักงานที่เป็น IT Support ซึ่งจะได้รับสิทธิ์แก้ไขการตั้งค่าสิทธิ์การมองเห็นปุ่มแชท Customer/Supplier เทียบเท่า Admin โดยไม่ต้องได้รับสิทธิ์ Admin เต็มรูปแบบ",
            "หมายเหตุ: ปัจจุบันสิทธิ์นี้ยังให้สิทธิ์แก้ไขข้อมูล TAG ในระบบ Work Place (หมวดหมู่/TAG/สมาชิก) เทียบเท่า Admin ด้วย ซึ่งกว้างกว่าที่ตั้งใจไว้ในตอนแรก อยู่ระหว่างรอยืนยันขอบเขตที่ถูกต้อง"
          ]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setItSupportUsers(e)}
                value={itSupportUsers}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(itSupportUsers, urls.SAVE_EMPLOYEE_WHO_ARE_IT_SUPPORT)}>Save</button>
            }
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          ผู้ดูแลระบบ (Admin)
          <HelpInfo infos={["กำหนดรายชื่อผู้ดูแลระบบ (Admin) ซึ่งมีสิทธิ์แก้ไขการตั้งค่าต่างๆ ในระบบทั้งหมด", "ต้องมีผู้ดูแลระบบอย่างน้อย 1 คนเสมอ ไม่สามารถลบออกจนไม่เหลือใครเลยได้"]} />
          <div className="d-flex justify-content-between">
            <div className="flex-grow-1 me-2">
              <Select
                isMulti={true}
                placeholder="สมาชิกที่จะ เพิ่ม/เอาออก"
                options={ddlUser}
                styles={Utils.GetThemeForReactSelect()}
                onChange={(e: any) => setAdminUsers(e)}
                value={adminUsers}
                isClearable={true}
                isDisabled={!isAdmin}
              ></Select>
            </div>
            {isAdmin &&
              <button className="btn btn-primary" onClick={() => onSaveEmployeeMultiSelect(adminUsers, urls.SAVE_ADMIN_USERS, true)}>Save</button>
            }
          </div>
        </div>
      </div>
    </>
  )
}

const DataSettingGeneral = () => {
  // const [editCol2Key, setEditCol2Key] = useState<any>(null);
  const onSetEditCol2Key = (key: any) => {
  }

  return (
    <MasterPage1Column
      titleText="กำหนดค่าการทำงานทั่วไป"
      titleIcon="fa fa-gears"
      // editCol2Key={editId}
      onSetEditCol2Key={onSetEditCol2Key}
      // capCol2={title2}
      componentCol1={<GeneralSettingComponent />}
    // componentCol2={<CategoryEdit editId={editId} onCatChange={onCatChange} canEdit={canEdit} />}
    ></MasterPage1Column>
  );
}

export default DataSettingGeneral;